import React from 'react';
import { useSelector } from 'react-redux';

import DiabetImage from '../../assets/images/death_reasons/diabetImage';
import DiabetEng from '../../assets/images/death_reasons/diabetEng';
import DiabetRus from '../../assets/images/death_reasons/diabetRus';
import Border from '../../assets/images/border';

import './diabet.scss';

const Diabet = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='diabet'>
            <Border />
            {language === 'ENG' ? <DiabetEng /> : <DiabetRus />}
            <DiabetImage />
            <span className='diabet-text'>
                {language === 'RUS' ? 'При высоком риске развития диабета обмен веществ может сильно нарушаться, способствуя появлению серьёзных осложнений и значительному сокращению срока жизни.' : 'High risk of developing diabetes can significantly disrupt metabolism, leading to serious complications and significantly shortening life expectancy.'}
            </span>
        </div>
    );
};

export default Diabet;